export default "__VITE_ASSET__69bb51b0__"